 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "cancellara-dist/js/" + ({"home-chunk~map-chunk~post-chunk~property-chunk~publics-chunk~search-chunk":"home-chunk~map-chunk~post-chunk~property-chunk~publics-chunk~search-chunk","home-chunk~property-chunk~publics-chunk~purchase-chunk~search-chunk":"home-chunk~property-chunk~publics-chunk~purchase-chunk~search-chunk","home-chunk~publics-chunk~purchase-chunk~search-chunk":"home-chunk~publics-chunk~purchase-chunk~search-chunk","home-chunk":"home-chunk","publics-chunk":"publics-chunk","search-chunk":"search-chunk","property-chunk":"property-chunk","map-chunk":"map-chunk","post-chunk":"post-chunk","purchase-chunk":"purchase-chunk","login-chunk":"login-chunk","maintenance-chunk":"maintenance-chunk"}[chunkId]||chunkId) + "." + {"chunk-04961750":"2203693e","chunk-2d0abf66":"e03b4c60","chunk-1438ed34":"cb7d764e","chunk-2d22d5f7":"f74b955e","chunk-4535239e":"a5275256","chunk-5a8cfdc8":"8c5f78d5","chunk-97f861d6":"070aff43","home-chunk~map-chunk~post-chunk~property-chunk~publics-chunk~search-chunk":"bc673caf","home-chunk~property-chunk~publics-chunk~purchase-chunk~search-chunk":"849097ab","home-chunk~publics-chunk~purchase-chunk~search-chunk":"b1f39957","home-chunk":"bdadfbbe","publics-chunk":"43861ba8","search-chunk":"f9716dd3","property-chunk":"44a52857","map-chunk":"bbff11d2","post-chunk":"77b20989","purchase-chunk":"1c47e8ba","login-chunk":"0eadcc66","maintenance-chunk":"8d27cf7b","chunk-708192a2":"6cfbc045","chunk-73bc94a7":"9ac614fd","chunk-9ad2ce60":"9ede8f69","chunk-ea773332":"61c0e281","chunk-3dcaf7e1":"d6f984a1","chunk-60dbdde7":"f295bccf","chunk-19c6514e":"cf71315d","chunk-5f736a57":"02f4b8ab","chunk-efcac706":"c50d8e8a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-04961750":1,"chunk-1438ed34":1,"chunk-4535239e":1,"chunk-97f861d6":1,"home-chunk~map-chunk~post-chunk~property-chunk~publics-chunk~search-chunk":1,"home-chunk~property-chunk~publics-chunk~purchase-chunk~search-chunk":1,"home-chunk~publics-chunk~purchase-chunk~search-chunk":1,"home-chunk":1,"publics-chunk":1,"search-chunk":1,"property-chunk":1,"map-chunk":1,"post-chunk":1,"purchase-chunk":1,"login-chunk":1,"maintenance-chunk":1,"chunk-708192a2":1,"chunk-73bc94a7":1,"chunk-9ad2ce60":1,"chunk-ea773332":1,"chunk-3dcaf7e1":1,"chunk-60dbdde7":1,"chunk-19c6514e":1,"chunk-5f736a57":1,"chunk-efcac706":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "cancellara-dist/css/" + ({"home-chunk~map-chunk~post-chunk~property-chunk~publics-chunk~search-chunk":"home-chunk~map-chunk~post-chunk~property-chunk~publics-chunk~search-chunk","home-chunk~property-chunk~publics-chunk~purchase-chunk~search-chunk":"home-chunk~property-chunk~publics-chunk~purchase-chunk~search-chunk","home-chunk~publics-chunk~purchase-chunk~search-chunk":"home-chunk~publics-chunk~purchase-chunk~search-chunk","home-chunk":"home-chunk","publics-chunk":"publics-chunk","search-chunk":"search-chunk","property-chunk":"property-chunk","map-chunk":"map-chunk","post-chunk":"post-chunk","purchase-chunk":"purchase-chunk","login-chunk":"login-chunk","maintenance-chunk":"maintenance-chunk"}[chunkId]||chunkId) + "." + {"chunk-04961750":"4d0eddc7","chunk-2d0abf66":"31d6cfe0","chunk-1438ed34":"a23a45c4","chunk-2d22d5f7":"31d6cfe0","chunk-4535239e":"a8045f66","chunk-5a8cfdc8":"31d6cfe0","chunk-97f861d6":"e1d9f401","home-chunk~map-chunk~post-chunk~property-chunk~publics-chunk~search-chunk":"4d0eddc7","home-chunk~property-chunk~publics-chunk~purchase-chunk~search-chunk":"4e729e14","home-chunk~publics-chunk~purchase-chunk~search-chunk":"f9b4da32","home-chunk":"8793437e","publics-chunk":"da063d1c","search-chunk":"28df53e3","property-chunk":"51c44580","map-chunk":"a60f14ad","post-chunk":"d00faa3e","purchase-chunk":"1a1766d3","login-chunk":"36667158","maintenance-chunk":"4d0eddc7","chunk-708192a2":"6b9df417","chunk-73bc94a7":"8a8dfe5d","chunk-9ad2ce60":"7e45d019","chunk-ea773332":"3cd5e9ac","chunk-3dcaf7e1":"fbb48a69","chunk-60dbdde7":"70be4cb6","chunk-19c6514e":"0e433876","chunk-5f736a57":"b6df9e9f","chunk-efcac706":"694da308"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://prod-dist.salabam.it/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
